(() => {
  'use strict';
  const products=[10831580135729,10831580201265,10838284501297,10838284468529];
  const giftVariants={workbook:51724047384881,stickers:51943608877361,tote:47446837985585,golden:51943498055985};
  const tierGifts={'tier-1':['workbook','stickers'],'tier-2':['workbook','stickers','tote'],'tier-4':['workbook','stickers','tote','golden']};
  function giftUpdates(cart){
    const groups=new Map(),updates={};
    for(const item of cart.items||[]){
      const p=item.properties||{};
      if(p._offer_id!=='sensory-tee-launch'||typeof p._group_id!=='string'||!p._group_id)continue;
      const group=groups.get(p._group_id)||{tier:p._tier_id,paid:[],gifts:[],invalid:false};groups.set(p._group_id,group);
      if(group.tier!==p._tier_id)group.invalid=true;
      if(p._role==='gift'){
        if(Object.values(giftVariants).includes(Number(item.variant_id))&&p._component==='gid://shopify/ProductVariant/'+item.variant_id)group.gifts.push(item);
        else group.invalid=true;
      }else if(['primary','paired'].includes(p._role)&&products.includes(Number(item.product_id))&&
        p._component==='gid://shopify/Product/'+item.product_id&&item.quantity===1)group.paid.push(item);
      else group.invalid=true;
    }
    for(const group of groups.values()){
      const counts=products.map(id=>group.paid.filter(item=>Number(item.product_id)===id).length);
      const total=group.paid.length,tier=group.tier;
      let valid=!group.invalid&&Object.hasOwn(tierGifts,tier);
      if(tier==='tier-1')valid=valid&&total===1;
      else{
        const amount=tier==='tier-2'?1:2;
        valid=valid&&((counts[0]===amount&&counts[1]===amount&&counts[2]===0&&counts[3]===0)||
          (counts[2]===amount&&counts[3]===amount&&counts[0]===0&&counts[1]===0));
      }
      const seen=new Set();
      for(const item of group.gifts){
        const key=item.properties._gift_id;
        const earned=valid&&tierGifts[tier].includes(key)&&giftVariants[key]===Number(item.variant_id)&&!seen.has(key);
        if(earned)seen.add(key);
        const quantity=earned?1:0;
        if(item.quantity!==quantity)updates[item.key]=quantity;
      }
    }
    return updates;
  }
  window.CloudNineSensoryOffers={giftUpdates};
})();
